// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ahxfekyakvpbghwqjtqk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFoeGZla3lha3ZwYmdod3FqdHFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1MDAwMTQsImV4cCI6MjA1MzA3NjAxNH0.kOOdlBEKVykmQr1oMIJrcN7x9_GTujAEMjKWLKuALUM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);